import { ILayoutContextData, LayoutReducerActionType, ILayoutReducerAction } from '@/types/layout';

export const layoutReducer = (state: ILayoutContextData, action: ILayoutReducerAction) => {
  switch (action.type) {
    case LayoutReducerActionType.updateGeoLocation:
      return {
        ...state,
        geoLocation: action.payload,
      };
    case LayoutReducerActionType.updateGeoLocationLoading:
      return {
        ...state,
        isGeoLocationLoading: action.payload,
      };
    case LayoutReducerActionType.updateIsModalOpen:
      return {
        ...state,
        isComparisonModalOpen: action.payload,
      };
    case LayoutReducerActionType.updateUtmData:
      return {
        ...state,
        utmData: action.payload,
      };
    case LayoutReducerActionType.updateDefaultContactItem:
      return {
        ...state,
        defaultContactItem: action.payload,
      };
    default:
      return state;
  }
};
